// Can be set in contentful page config
export const DEFAULT = 'default';
export const AFFILIATE = 'affiliate';
